import "../../styles/style_boutique.css";

export default function CategoryFilter({ categories, selectedCategory, onSelect }) {
  return (
    <div className="category-filter">
      <button
        className={`category-btn ${selectedCategory === "all" ? "active" : ""}`}
        onClick={() => onSelect("all")}
      >
        <ion-icon name="apps-outline"></ion-icon>
        <span>Tout</span>
      </button>
      
      {categories.map((category) => (
        <button
          key={category.id}
          className={`category-btn ${selectedCategory === category.libelle ? "active" : ""}`}
          onClick={() => onSelect(category.libelle)}
        >
          <span className="category-icon">{getCategoryIcon(category.libelle)}</span>
          <span>{category.libelle}</span>
        </button>
      ))}
    </div>
  );
}

// Associer des icônes aux catégories
function getCategoryIcon(categoryName) {
  const iconMap = {
    "Bouquets": "💐",
    "Compositions": "🎨",
    "Plantes": "🪴",
    "Cadeaux": "🎁",
    "Deuil": "🕊️",
    "Mariage": "💒",
    "Anniversaire": "🎂",
    "Fête des mères": "💝",
    "Saint-Valentin": "❤️",
    "Noël": "🎄"
  };
  
  return iconMap[categoryName] || "🌸";
}
